import $windowConfig from '../WindowConfig.js'
import $search from '../WindowSearch'
import { axiosP, axiosG, Api } from './index.js'

export default {
  /**
   * 2.4.9 记录中行交易手机号和公众号用户id
   * * [rap](https://rap.eoms.phone580.com/workspace/myWorkspace.do?projectId=29#1173)
   * * 负责人：恒聪
   * * 成功返回：resp.success:true
   * * 失败返回：resp.success: false
   * * errorCode: "440045","行为编号对应的手机号码已存在"，提示用户已经报名
   * * errorCode: "440046","行为编号对应的openid已存在"，提示用户已经报名
   * * errorMsg: ''
   * @param data {object} {token|userId|mobile}
   * @return {*|Promise<any>}
   */
  recordBocMobileOpenId (data = {}) {
    const { clientId, authType } = $windowConfig
    const { token, mobile, userId, actionNo } = data
    const param = {
      authType,
      clientId,
      actionNo,
      ext: JSON.stringify({
        myAuthToken: token
      }),
      openId: mobile,
      userId,
    }
    return axiosP(Api.secKill + 'fmapi/api/action/record-boc-mobile-openid', param)
  }
}
